import { PORTS } from "../config/modulePort";
import api from "./Api";
import axios from "axios";

interface ValidateUserRequest {
  userName: string;
  password: string;
  deviceId: string;
  deviceName: string;
}

interface ValidateUserResponse {
  isSuccess: boolean;
  message: string;
  statusCode: string;
  timestamp: string;
  result: {
    userid: number;
    username: string;
    countersign: number;
    emailid: string;
    tenantid: number;
    companyid: number;
    isactive: number;
    createdby: number;
    createddate: string;
    modifiedby: number;
    modifieddate: string;
    departmentid: number;
    subdepartmentid: number;
    roleid: number;
    department: string;
    subdepartment: string;
    tokenValue: string;
    tokenexpirydate: string;
    salutationtypeid: number;
    firstname: string;
    middlename: string;
    lastname: string;
    genderid: number;
    phonenumber: number;
    faxnumber: number;
    usertypeid: number;
    registrationdate: string;
    isaccountverified: number;
    accountverificationdate: string;
    isfirsttimelogin: number;
    firsttimelogindate: string;
    islockuser: number;
    lastuserlockdate: string;
    ismfa: number;
    lastmfaactiviationdate: string;
    lastmfadeactivationdate: string;
    passwordexpirydate: string;
    isforcepasswordexpiry: number;
    lastforcepasswordexpiredate: string;
    company: string;
    gender: string;
    useroleids: string;
    currentAppRoleDesc: string;
  };
}
interface ValidateMFACodeRequest {
  UserId: number;
  deviceId: string;
  deviceName: string;
  MFACode: string;
}
interface ValidateMFACodeResponse {
  isSuccess: boolean;
  message: string;
  statusCode: string;
  timestamp: string;
  result: {
    userid: number;
    username: string;
    countersign: number;
    emailid: string;
    tenantid: number;
    companyid: number;
    isactive: number;
    createdby: number;
    createddate: string;
    modifiedby: number;
    modifieddate: string;
    departmentid: number;
    subdepartmentid: number;
    roleid: number;
    department: string;
    subdepartment: string;
    tokenValue: string;
    tokenexpirydate: string;
    salutationtypeid: number;
    firstname: string;
    middlename: string;
    lastname: string;
    genderid: number;
    phonenumber: number;
    faxnumber: number;
    usertypeid: number;
    registrationdate: string;
    isaccountverified: number;
    accountverificationdate: string;
    isfirsttimelogin: number;
    firsttimelogindate: string;
    islockuser: number;
    lastuserlockdate: string;
    ismfa: number;
    lastmfaactiviationdate: string;
    lastmfadeactivationdate: string;
    passwordexpirydate: string;
    isforcepasswordexpiry: number;
    lastforcepasswordexpiredate: string;
    company: string;
    gender: string;
    useroleids: string;
    userroledescription: string;
  };
}
interface ChangePasswordRequest {
  Userid: number;
  OldPassword: string;
  NewPassword: string;
  ReasonCode: number;
}
interface ChangePasswordResponse {
  isSuccess: boolean;
  message: string;
  statusCode: string;
  timestamp: string;
  result: {
    userid: number;
    username: string;
    countersign: number;
    emailid: string;
    tenantid: number;
    companyid: number;
    isactive: number;
    createdby: number;
    createddate: string;
    modifiedby: number;
    modifieddate: string;
    departmentid: number;
    subdepartmentid: number;
    roleid: number;
    department: string;
    subdepartment: string;
    tokenvalue: string;
    tokenexpirydate: string;
    salutationtypeid: number;
    firstname: string;
    middlename: string;
    lastname: string;
    genderid: number;
    phonenumber: number;
    faxnumber: number;
    usertypeid: number;
    registrationdate: string;
    isaccountverified: number;
    accountverificationdate: string;
    isfirsttimelogin: number;
    firsttimelogindate: string;
    islockuser: number;
    lastuserlockdate: string;
    ismfa: number;
    lastmfaactiviationdate: string;
    lastmfadeactivationdate: string;
    passwordexpirydate: string;
    isforcepasswordexpiry: number;
    lastforcepasswordexpiredate: string;
    company: string;
    gender: string;
    useroleids: string;
    userroledescription: string;
  };
}
interface FeatureAccessResponse {
  isSuccess: boolean;
  message: string;
  statusCode: string;
  timestamp: string;
  result: {
    featureId: number;
    featureDesc: string;
  };
}
interface SignOutRequest {
  Userid: number;
  loginType: string;
  deviceId: string;
  deviceName: string;
}
interface ResendUserRequest {
  Userid: number;
  deviceId: string;
  deviceName: string;
}
interface ForgotResponseResponse {
  isSuccess: boolean;
  message: string;
  statusCode: string;
  timestamp: string;
  result: {
    userId: number;
    userFullName: string;
    tenantId: number;
    responseMessage: string;
    responseCode: string;
  };
}
export const ValidateUser = async (
  userData: ValidateUserRequest
): Promise<ValidateUserResponse> => {
  try {
    const BASE_URL = process.env.REACT_APP_AUTH_URL || "";
    if (!BASE_URL) {
      throw new Error(
        "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
      );
    }
    const ValidateUserAPI = api(BASE_URL); // Pass the guaranteed string
    const response = await ValidateUserAPI.post<ValidateUserResponse>(
      "/api/authenticate/user",
      userData
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching team data:", error);
    throw new Error("Failed to fetch the team data. Please try again.");
  }
};

export const ChangePassword = async (
  data: ChangePasswordRequest
): Promise<ChangePasswordResponse> => {
  const BASE_URL = process.env.REACT_APP_AUTH_URL || ""; // Default to an empty string or another default value

  if (!BASE_URL) {
    throw new Error(
      "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
    );
  }

  const ChangePasswordAPI = api(BASE_URL);
  const response = await ChangePasswordAPI.post<ChangePasswordResponse>(
    "/api/authenticate/changepassword",
    data
  );
  return response.data;
};
export const ValidateMFACode = async (
  data: ValidateMFACodeRequest
): Promise<ValidateMFACodeResponse> => {
  const BASE_URL = process.env.REACT_APP_AUTH_URL || ""; // Default to an empty string or another default value

  if (!BASE_URL) {
    throw new Error(
      "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
    );
  }

  const ValidateMFACodeAPI = api(BASE_URL);

  const response = await ValidateMFACodeAPI.post<ValidateMFACodeResponse>(
    "/api/authenticate/mfacode",
    data
  );
  return response.data;
};
export const FeatureAccess = async (
  token: string
): Promise<FeatureAccessResponse> => {
  const BASE_URL = process.env.REACT_APP_USER_MGMT_URL || ""; // Default to an empty string or another default value

  if (!BASE_URL) {
    throw new Error(
      "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
    );
  }
  const FeatureAccessAPI = api(BASE_URL);
  const response = await FeatureAccessAPI.get<FeatureAccessResponse>(
    "/api/user/userlookup/featureaccess",
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};
export const SignOut = async (
  data: SignOutRequest
): Promise<ChangePasswordResponse> => {
  const BASE_URL = process.env.REACT_APP_AUTH_URL || "";

  if (!BASE_URL) {
    throw new Error(
      "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
    );
  }
  const SignOutAPI = api(BASE_URL);
  const response = await SignOutAPI.post<ChangePasswordResponse>(
    "/api/authenticate/signout",
    data
  );
  return response.data;
};
export const ResendMFACode = async (
  userData: ResendUserRequest
): Promise<ValidateUserResponse> => {
  try {
    const BASE_URL = process.env.REACT_APP_AUTH_URL || "";

    if (!BASE_URL) {
      throw new Error(
        "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
      );
    }

    const ValidateUserAPI = api(BASE_URL); // Pass the guaranteed string
    const response = await ValidateUserAPI.post<ValidateUserResponse>(
      "/api/authenticate/resendmfacode",
      userData
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching team data:", error);
    throw new Error("Failed to fetch the team data. Please try again.");
  }
};

export const AccountVerification = async (
  tokenPass: string
): Promise<ValidateUserResponse> => {
  const BASE_URL = process.env.REACT_APP_USER_MGMT_URL || "";

  if (!BASE_URL) {
    throw new Error(
      "BASE_URL is undefined. Please set REACT_APP_USER_MGMT_URL in your environment variables."
    );
  }

  const response = await axios.get<ValidateUserResponse>(
    `${BASE_URL}api/user/verify`,
    {
      headers: {
        Authorization: `Bearer ${tokenPass}`,
      },
    }
  );

  return response.data;
};

export const IsAccountVerified = async (
  token: string
): Promise<ValidateUserResponse> => {
  const BASE_URL = process.env.REACT_APP_USER_MGMT_URL || "";

  if (!BASE_URL) {
    throw new Error("BASE_URL is undefined.");
  }

  const response = await axios.get<ValidateUserResponse>(
    `${BASE_URL}api/user/isverified`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const ForgotPassword = async (
  email: string
): Promise<ForgotResponseResponse> => {
  const BASE_URL = process.env.REACT_APP_AUTH_URL || ""; // Default to an empty string or another default value

  if (!BASE_URL) {
    throw new Error(
      "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
    );
  }

  const forgotAPI = api(BASE_URL);
  const response = await forgotAPI.get<ForgotResponseResponse>(
    `/api/authenticate/email?emailId=${encodeURIComponent(email)}`
  );

  return response.data;
};
export const ResetPassword = async (
  newCounterSign: string,
  token: string
): Promise<ForgotResponseResponse> => {
  try {
    const BASE_URL = process.env.REACT_APP_AUTH_URL || "";

    if (!BASE_URL) {
      throw new Error(
        "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
      );
    }

    const ResetUserAPI = api(BASE_URL);

    const response = await ResetUserAPI.post<ForgotResponseResponse>(
      `/api/authenticate/reset/password?newCounterSign=${encodeURIComponent(
        newCounterSign
      )}`, // Pass as query param
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error(
      "Error resetting password:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message ||
        "Failed to reset the password. Please try again."
    );
  }
};
export const GetUserRole = async (token: string): Promise<any> => {
  const BASE_URL = process.env.REACT_APP_USER_MGMT_URL || "";

  if (!BASE_URL) {
    throw new Error(
      "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
    );
  }
  const FeatureAccessAPI = api(BASE_URL);
  const response = await FeatureAccessAPI.get<any>(
    "/api/user/userlookup/role/list",
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};
export const SwitchUserRole = async (data: any): Promise<any> => {
  const BASE_URL = process.env.REACT_APP_USER_MGMT_URL || "";

  if (!BASE_URL) {
    throw new Error(
      "BASE_URL is undefined. Please set REACT_APP_AUTH_URL in your environment variables."
    );
  }

  const FeatureAccessAPI = api(BASE_URL);
  const response = await FeatureAccessAPI.put<any>(
    "/api/user/role/update",
    data
  );
  return response.data;
};
